import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from "react";
import { useIntl } from "react-intl";
import { prodListHeaderCommonMsg } from "@temp/intl";
import { StringParam, useQueryParam } from "use-query-params";
import { Loader } from "@components/atoms";
import { useParams } from "react-router-dom";
import { MetaWrapper, NotFound, OfflinePlaceholder, MainMenu } from "../../components";
import NetworkStatus from "../../components/NetworkStatus";
import { PRODUCTS_PER_PAGE } from "../../core/config";
import { convertSortByFromString, convertToAttributeScalar, getGraphqlIdFromDBId, maybe } from "../../core/utils";
import Page from "./Page";
import { TypedCollectionProductsDataQuery, TypedCollectionProductsQuery } from "./queries";
export var FilterQuerySet = {
  encode: function encode(valueObj) {
    var str = [];
    Object.keys(valueObj).forEach(function (value) {
      str.push("".concat(value, "_").concat(valueObj[value].join("_")));
    });
    return str.join(".");
  },
  decode: function decode(strValue) {
    var obj = {};
    var propsWithValues = strValue.split(".").filter(function (n) {
      return n;
    });
    propsWithValues.map(function (value) {
      var propWithValues = value.split("_").filter(function (n) {
        return n;
      });
      obj[propWithValues[0]] = propWithValues.slice(1);
    });
    return obj;
  }
};
export var View = function View() {
  var _useParams = useParams(),
      id = _useParams.id;

  var _useQueryParam = useQueryParam("sortBy", StringParam),
      _useQueryParam2 = _slicedToArray(_useQueryParam, 2),
      sort = _useQueryParam2[0],
      setSort = _useQueryParam2[1];

  var _useQueryParam3 = useQueryParam("filters", FilterQuerySet),
      _useQueryParam4 = _slicedToArray(_useQueryParam3, 2),
      attributeFilters = _useQueryParam4[0],
      setAttributeFilters = _useQueryParam4[1];

  var intl = useIntl();

  var clearFilters = function clearFilters() {
    setAttributeFilters({});
  };

  var onFiltersChange = function onFiltersChange(name, value) {
    if (attributeFilters && attributeFilters.hasOwnProperty(name)) {
      if (attributeFilters[name].includes(value)) {
        if (filters.attributes["".concat(name)].length === 1) {
          var att = _objectSpread({}, attributeFilters);

          delete att["".concat(name)];
          setAttributeFilters(_objectSpread({}, att));
        } else {
          setAttributeFilters(_objectSpread(_objectSpread({}, attributeFilters), {}, _defineProperty({}, "".concat(name), attributeFilters["".concat(name)].filter(function (item) {
            return item !== value;
          }))));
        }
      } else {
        setAttributeFilters(_objectSpread(_objectSpread({}, attributeFilters), {}, _defineProperty({}, "".concat(name), [].concat(_toConsumableArray(attributeFilters["".concat(name)]), [value]))));
      }
    } else {
      setAttributeFilters(_objectSpread(_objectSpread({}, attributeFilters), {}, _defineProperty({}, "".concat(name), [value])));
    }
  };

  var filters = {
    attributes: attributeFilters,
    pageSize: PRODUCTS_PER_PAGE,
    priceGte: null,
    priceLte: null,
    sortBy: sort || null
  };

  var variables = _objectSpread(_objectSpread({}, filters), {}, {
    attributes: filters.attributes ? convertToAttributeScalar(filters.attributes) : {},
    id: getGraphqlIdFromDBId(id, "Collection"),
    sortBy: convertSortByFromString(filters.sortBy)
  });

  var sortOptions = [{
    label: intl.formatMessage(prodListHeaderCommonMsg.sortOptionsClear),
    value: null
  }, {
    label: intl.formatMessage(prodListHeaderCommonMsg.sortOptionsPrice),
    value: "price"
  }, {
    label: intl.formatMessage(prodListHeaderCommonMsg.sortOptionsPriceDsc),
    value: "-price"
  }, {
    label: intl.formatMessage(prodListHeaderCommonMsg.sortOptionsName),
    value: "name"
  }, {
    label: intl.formatMessage(prodListHeaderCommonMsg.sortOptionsNameDsc),
    value: "-name"
  }, {
    label: intl.formatMessage(prodListHeaderCommonMsg.sortOptionsUpdatedAt),
    value: "updated_at"
  }, {
    label: intl.formatMessage(prodListHeaderCommonMsg.sortOptionsUpdatedAtDsc),
    value: "-updated_at"
  }];
  return React.createElement(React.Fragment, null, React.createElement(MainMenu, {
    goback: false,
    search: true,
    cart: true
  }), React.createElement(NetworkStatus, null, function (isOnline) {
    return React.createElement(TypedCollectionProductsDataQuery, {
      variables: variables,
      errorPolicy: "all",
      loaderFull: true
    }, function (collectionData) {
      var _collectionData$data, _collectionData$data$, _collectionData$data2, _collectionData$data3;

      if (collectionData.loading) {
        return React.createElement(Loader, null);
      }

      if (collectionData.data && collectionData.data.collection === null) {
        return React.createElement(NotFound, null);
      }

      if (!isOnline) {
        return React.createElement(OfflinePlaceholder, null);
      }

      var canDisplayFilters = !!((_collectionData$data = collectionData.data) === null || _collectionData$data === void 0 ? void 0 : (_collectionData$data$ = _collectionData$data.attributes) === null || _collectionData$data$ === void 0 ? void 0 : _collectionData$data$.edges) && !!((_collectionData$data2 = collectionData.data) === null || _collectionData$data2 === void 0 ? void 0 : (_collectionData$data3 = _collectionData$data2.collection) === null || _collectionData$data3 === void 0 ? void 0 : _collectionData$data3.name);
      return React.createElement(TypedCollectionProductsQuery, {
        variables: variables
      }, function (collectionProductsData) {
        if (!canDisplayFilters && collectionProductsData.loading) {
          return React.createElement(Loader, null);
        }

        if (canDisplayFilters) {
          var handleLoadMore = function handleLoadMore() {
            return collectionProductsData.loadMore(function (prev, next) {
              return {
                collection: _objectSpread(_objectSpread({}, prev.collection), {}, {
                  products: _objectSpread(_objectSpread({}, prev.collection.products), {}, {
                    edges: [].concat(_toConsumableArray(prev.collection.products.edges), _toConsumableArray(next.collection.products.edges)),
                    pageInfo: next.collection.products.pageInfo
                  })
                })
              };
            }, {
              after: collectionProductsData.data.collection.products.pageInfo.endCursor
            });
          };

          return React.createElement(MetaWrapper, {
            meta: {
              description: collectionData.data.collection.seoDescription,
              title: collectionData.data.collection.seoTitle,
              type: "product.collection"
            }
          }, React.createElement(Page, {
            clearFilters: clearFilters,
            attributes: collectionData.data.attributes.edges.map(function (edge) {
              return edge.node;
            }),
            collection: collectionData.data.collection,
            displayLoader: collectionData.loading,
            hasNextPage: maybe(function () {
              return collectionProductsData.data.collection.products.pageInfo.hasNextPage;
            }, false),
            sortOptions: sortOptions,
            activeSortOption: filters.sortBy,
            filters: filters,
            products: collectionProductsData.data.collection.products,
            onAttributeFiltersChange: onFiltersChange,
            onLoadMore: handleLoadMore,
            activeFilters: filters.attributes ? Object.keys(filters.attributes).length : 0,
            onOrder: function onOrder(value) {
              setSort(value.value);
            }
          }));
        }

        return React.createElement(React.Fragment, null);
      });
    });
  }));
};
export default View;